module.exports = __webpack_public_path__ + "algo_icon.svg?a25dd812295506712679a989e55d504a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/algo_icon.svg
// module id = 1144
// module chunks = 2